import "./WhyChoose.css";
import { Col, Container, Row } from "react-bootstrap";
const whyChooseBg = `${process.env.REACT_APP_API_URL}/assests/images/whychoose/why_choose_bg.webp`;
const support = `${process.env.REACT_APP_API_URL}/assests/images/whychoose/support.webp`;
const priceTag = `${process.env.REACT_APP_API_URL}/assests/images/whychoose/price-tag-discount.webp`;
const brokerage = `${process.env.REACT_APP_API_URL}/assests/images/whychoose/brokerage.webp`;
const contract = `${process.env.REACT_APP_API_URL}/assests/images/whychoose/contract.webp`;
const loanIcon = `${process.env.REACT_APP_API_URL}/assests/images/whychoose/loan.webp`;

const whyChooseList = [
    {
        icon: support,
        title: "365 Days Customer Support",
        text: "Contact Us to resolve Issues related to Buying a good Home",
    },
    {
        icon: priceTag,
        title: "Personalized Exclusive",
        text: "Avail From Our Personalized Offer to make Home Buying Experience Pleasant",
    },
    {
        icon: brokerage,
        title: "Zero Brokerage",
        text: "Avail From Our Personalized Offer to make Home Buying Experience Pleasant",
    },
    {
        icon: contract,
        title: "Perfect Documentation",
        text: "Meet Our Team to Manage the Process of Documentation Perfectly",
    },
    {
        icon: loanIcon,
        title: "Home Loan Assistance",
        text: "Take Our Home Loan Consultation to Find the best Financing Opportunity",
    }
]

const WhyChoose = () => {
    return(
        <div className="why_choose_section padding-top padding-bottom" id="whyus">
            <img src={whyChooseBg} alt="Why Choose" className="why_choose_bg" />
            <Container>
                <Row>
                    <Col>
                        <h2 className="why_choose_heading">Why Choose Us</h2>
                        <div className="why_choose_grid_lists">
                            {whyChooseList.map((item,i) => (
                                <div className="why_choose_list_item" key={i}>
                                    <img src={item.icon} alt={item.title} className="why_choose_icon" />
                                    <h3 className="why_choose_list_title">{item.title}</h3>
                                    <p className="why_choose_list_text">{item.text}</p>
                                </div>
                            ))}
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default WhyChoose